import styled, { css } from 'styled-components';
import Modal from '@deprecated-ui/common/Modal';
import { Form, Input } from 'antd';
import { BondsModalTypeEnum } from './constants';

export const ModalRoot = styled(Modal).attrs({
  width: 'auto',
  type: 'transparent',
  centered: true,
})`
  min-height: 264px;
  min-width: 415px;

  padding: 20px;

  max-width: 100%;

  .ant-modal-close {
    display: none;
  }
`;

export const ModalContainer = styled.div<{ modalType?: BondsModalTypeEnum }>`
  position: relative;
  min-height: 126px;

  background-color: #ffffff;
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 16px;

  ${(p) =>
    p.modalType === BondsModalTypeEnum.TRANSACTION &&
    css`
      min-width: 503px;
    `}
`;

export const ModalHeader = styled.div``;

export const ModalBody = styled.div`
  .ant-form-item {
    margin-bottom: 20px;
  }
  .ant-slider-rail {
    background-color: #dadada;
    display: block;
  }
  .ant-row.ant-form-item {
    height: 24px;
  }
`;

export const ModalFooter = styled.div``;

export const InputSectionWrapper = styled.div`
  border-bottom: 1px solid #dadada;
`;

export const Field = styled.div<{ isAccordion?: boolean }>`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: ${(p) => (p.isAccordion ? '16px' : 0)};
`;

export const FieldSet = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 0;
`;

export const BorderedContainer = styled.div`
  padding: 16px 20px;
  margin: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #ededed;
  border-radius: 4px;
`;

export const TextLoadingShimmer = styled.div<{ width: string; height: string }>`
  display: block;
  background-color: #ededed;
  border-radius: 4px;
  height: ${(p) => p.height || '16px'};
  width: ${(p) => p.width || '100%'};
`;

export const FormItem = styled(Form.Item)<{ disabled?: boolean }>`
  .ant-form-item-control-input {
    background-color: ${(props) =>
      props.disabled ? '#f7f7f7' : 'transparent'};
    border: ${(props) => (props.disabled ? '1px solid #dadada' : 'none')};
    padding-left: ${(props) => (props.disabled ? '8px' : 'unset')};
    color: ${(props) => (props.disabled ? '#858585' : 'unset')};
    border-radius: 2px;
  }
`;

export const UnitInput = styled(Input)`
  /* Firefox */
  -moz-appearance: textfield !important;

  :focus::placeholder {
    color: transparent;
  }
  ::placeholder {
    letter-spacing: -1px;
  }

  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;

    margin: 0;
  }

  caret-color: #1db87a;
`;

export const HistoryGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  width: 100%;
  padding: 8px 0px;
  border-bottom: 1px solid #f1f1f1;

  :last-of-type {
    border-bottom: none;
  }
`;

export const CouponHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 2px;

  min-height: 360px;
  max-height: 400px;

  overflow-y: scroll;
  overflow-x: hidden;

  scroll-behavior: smooth;
`;
